import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2707dbc&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2707dbc')) {
      api.createRecord('c2707dbc', component.options)
    } else {
      api.reload('c2707dbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c2707dbc&lang=pug", function () {
      api.rerender('c2707dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/consultant/classRecords/vipEvaluationTable/vipFeedbackField/index.vue"
export default component.exports